import { render, staticRenderFns } from "./ProdutoForm.vue?vue&type=template&id=1e418263&lang=html"
import script from "./ProdutoForm.vue?vue&type=script&lang=js"
export * from "./ProdutoForm.vue?vue&type=script&lang=js"
import style0 from "./ProdutoForm.vue?vue&type=style&index=0&id=1e418263&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports